import { Cancel } from '@material-ui/icons'
import React from 'react'
import {
  Edit,
  EditProps,
  SaveButton,
  ShowButton,
  SimpleForm,
  TextInput,
  Toolbar,
  ToolbarProps,
  useTranslate,
} from 'react-admin'
import { NotificationTagDto } from '../../../core/dto/system-notifications/notification-tag.dto'

const validateNotificationTagEdit = (values: NotificationTagDto) => {
  const errors: { [n: string]: string } = {}
  if (!values.description) {
    errors.description = 'ra.validation.required'
  }
  return errors
}

const EditTitle = () => {
  const translate = useTranslate()
  return <span>{translate('resources.notification-tags.titles.edit')}</span>
}

const EditToolbar = (props: ToolbarProps) => (
  <Toolbar {...props}>
    <SaveButton />
    <ShowButton icon={<Cancel />} label="const.cancel" />
  </Toolbar>
)

export const NotificationTagEdit = (props: EditProps) => (
  <Edit {...props} title={<EditTitle />}>
    <SimpleForm
      redirect="show"
      validate={validateNotificationTagEdit}
      toolbar={<EditToolbar />}
    >
      <TextInput source="description" isRequired />
    </SimpleForm>
  </Edit>
)
